var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',{staticClass:"mr-2",attrs:{"small":"","type":"button","b-tooltip.hover":"","title":_vm.getTooltipTitle()},on:{"click":_vm.copy}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }